import { useEffect } from 'react';

const getCurrentElement = (elementId) => document.getElementById(elementId);

export function useCustomStyles({ css, customId }) {
  const pageStyles = css || '';
  const styleTagId = `custom-css-${customId}`;

  useEffect(() => {
    const customCssStyleTag = getCurrentElement(styleTagId);
    if (customCssStyleTag) {
      customCssStyleTag.innerHTML = pageStyles;
    } else {
      document.head.insertAdjacentHTML('beforeend', `<style id=${styleTagId} type="text/css">${pageStyles}</style>`);
    }

    return () => {
      const customCssStyleTag = getCurrentElement(styleTagId);
      if (customCssStyleTag) customCssStyleTag.remove();
    };
  }, [pageStyles, styleTagId]);
}

export function useCustomFonts({ landingItem, customId }) {
  const pageFonts = landingItem?.customFonts || [];
  const fontTagId = `custom-fonts-${customId}`;

  const getFontFormat = (filename) => {
    const fontExtension = filename.split('.').pop();
    switch (fontExtension) {
      case 'woff':
        return ' format("woff")';
      case 'woff2':
        return ' format("woff2")';
      case 'ttf':
        return ' format("truetype")';
      case 'svg':
        return ' format("svg")';
      default:
        return '';
    }
  };

  const fontsString = pageFonts.map((font) => {
    return `
      @font-face {
        font-weight: ${font?.fontWeight};
        font-style: ${font?.fontStyle};
        font-family: '${font?.fontFamily}';
        src: url('${font?.url}')${getFontFormat(font?.filename)};
        font-display: swap;
      }

    `;
  });
  const fontsStringFormat = fontsString.join(' ');

  useEffect(() => {
    const customFontTag = getCurrentElement(fontTagId);
    if (customFontTag) {
      customFontTag.innerHTML = fontsStringFormat;
    } else {
      document.head.insertAdjacentHTML(
        'beforeend',
        `<style id=${fontTagId} type="text/css">${fontsStringFormat}</style>`,
      );
    }
    return () => {
      const customFontTag = getCurrentElement(fontTagId);
      if (customFontTag) customFontTag.remove();
    };
  }, [fontsStringFormat, fontTagId]);
}
